import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { history, ReduxStore } from 'Redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import App from 'Components/App';
import ScrollToTop from 'Common/ScrollToTop';
import { setupSentry } from 'Utils/sentry';
import * as serviceWorker from './serviceWorker';

import packageJson from '../package.json';

setupSentry(packageJson.name, packageJson.version);

ReactDOM.render(
  <Provider store={ReduxStore}>
    <ConnectedRouter history={history}>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('profile-frontend')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
